import { Protocol } from './index';
import { Category } from '../constants';

const onchainSummer: Protocol[] = [
  {
    name: 'GhostGraph',
    url: 'https://ghostgraph.xyz',
    logoPath: '/logos/ghostlogs.xyz.jpg',
    category: Category.OnchainSummer,
    twitterUrl: 'https://twitter.com/0xGhostLogs',
  },
];

export { onchainSummer };
